import { createActionGroup, props } from '@ngrx/store';
import { ToastType } from '@rtr-factory/ui/toast';

export const toastActions = createActionGroup({
  source: 'toast',
  events: {
    'Show Single Toast': props<{
      text: string;
      toastType?: ToastType;
      translationValues?: { [key: string]: string };
    }>(),
    'Show Stacked Toast': props<{
      text: string;
      translationValues?: { [key: string]: string };
    }>(),
  },
});
